import firebase from '@firebase/app'
import UserSettingsDB from '../../firebase/user-settings-db'
import '@firebase/firestore'

export default {
  /**
   * Fetch settings of current loggedin user
   */
  getUserSettings: async ({ rootState, commit }) => {
    let userLanguage = 'en'
    if (localStorage.getItem('language')) {
      const startLang = JSON.parse(localStorage.getItem('language'))
      userLanguage = startLang
    }

    const settingsRef = firebase
      .firestore()
      .collection('settings')
      .doc(rootState.authentication.user.id)

    settingsRef.get().then(docSnapshot => {
      if (docSnapshot.exists) {
        settingsRef.onSnapshot(doc => {
          commit('setSettings', doc.data())
        })
      } else {
        settingsRef
          .set({
            longitude: '-73.985428',
            latitude: '40.748817',
            location: 'New York',
            region: 'NY',
            country: 'US',
            currency: 'USD',
            timezone: 'EST',
            userLang: userLanguage
          })
          // eslint-disable-next-line func-names
          .then(function() {
            commit('setSettings', {
              longitude: '-73.985428',
              latitude: '40.748817',
              location: 'New York',
              region: 'NY',
              country: 'US',
              currency: 'USD',
              timezone: 'EST',
              userLang: userLanguage
            })
            commit('setSettingsCreationPending', false)
          })
          // eslint-disable-next-line func-names
          .catch(function(error) {
            console.error('Error writing document: ', error)
          })
      }
    })
  },

  /**
   * Create a settings for current loggedin user
   */
  createUserSettings: async ({ commit, rootState }, settings) => {
    commit('setSettingsCreationPending', true)
    // eslint-disable-next-line no-unused-vars
    const createSettings = firebase
      .firestore()
      .collection('settings')
      .doc(rootState.authentication.user.id)
      .set({
        settings
      })
      // eslint-disable-next-line func-names
      .then(function() {
        commit('setSettings', settings)
        commit('setSettingsCreationPending', false)
      })
      // eslint-disable-next-line func-names
      .catch(function(error) {
        console.error('Error writing document: ', error)
      })
  },

  /**
   * Delete a user dashboard from its id
   */
  deleteUserSettings: async ({ rootState, commit, getters }, settingsId) => {
    if (getters.isSettingsDeletionPending(settingsId)) return

    const userSettingsDb = new UserSettingsDB(rootState.authentication.user.id)

    commit('addSettingsDeletionPending', settingsId)
    await userSettingsDb.delete(settingsId)
    commit('removeSettingsById', settingsId)
    commit('removeSettingsDeletionPending', settingsId)
  },
  /**
   * UPDATE DATA FOR A WIDGET
   */
  updateSettingsData({ rootState }, payload) {
    const docRef = firebase
      .firestore()
      .collection('settings')
      .doc(rootState.authentication.user.id)
    docRef.update(payload)
  }
}
